import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const workspaceSchema = {
    "workspace": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "color": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.COLOR,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "workspaceApiKey": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "key": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.TOKEN,
            value: "",
        },
        "allowedIp": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "workspaceConfig": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "key": {
            type: DATA_TYPE.ENUM,
            enum: "WorkspaceConfigKey",
            value: null,
        },
        "value": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.VALUE,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "workspaceData": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "value": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.VALUE,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "externalApiLog": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "apiKey": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.KEY,
            value: "",
        },
        "httpMethod": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "requestUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "queryString": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "statusCode": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "clientIp": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.IP,
            value: "",
        },
        "userAgent": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.USER_AGENT,
            value: "",
        },
        "requestBody": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "responseBody": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "success": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "processingTime": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    },

    "systemStatus": {
        "cpuUsage": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "memoryTotal": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "memoryUsed": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "memoryFree": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "memoryUsage": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "jvmHeapMax": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "jvmHeapUsed": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "jvmHeapUsage": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "uploadFolderSize": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "uploadPath": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.FILE_PATH,
            value: "",
        },
    }
} as const;
